import { LyMainProductFormBase } from "./base"

if (!customElements.get('ly-main-product-form-buy-buttons')) {
    customElements.define('ly-main-product-form-buy-buttons', class extends LyMainProductFormBase {
        connectedCallback() {
            super.connectedCallback()

            this.form = this.querySelector('form')
            this.input = this.form.querySelector('input[name="id"]')
            this.submitButton = this.querySelector('[type=submit]')
            this.spinner = this.querySelector('.loading__spinner')

            this.pickupDom = this.querySelector('pickup-availability')

            this.form.addEventListener('submit', this.handleSubmit)
        }

        disconnectedCallback() {
            this.form.removeEventListener('submit', this.handleSubmit)

            super.disconnectedCallback()
        }

        handleSubmit = async (evt) => {
            evt.preventDefault()

            if (this.submitButton.disabled) return

            this.handleErrorMessage()
            this.startLoading()

            try {
                const config = await this.buildHttpConfig()

                const response = await fetch('/cart/add.js', config).then(res => res.json())

                if (response.status) {
                    this.error = true
                    throw new Error(response.description)
                }

                if (!this.error) {
                    window.publish('bus:cart_updated')
                }

                this.error = false

                window.location = '/cart'
            } catch (error) {
                this.handleErrorMessage(error.message)
                console.error(error)
            } finally {
                this.stopLoading()
            }
        }

        buildHttpConfig = async () => {
            const config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            }

            const items = []

            const thisFormData = new FormData(this.form)
            const t = thisFormData.get('id') + '' + Date.now()

            const _props = { _t: t, _v: 'v2' }

            const primaryItem = {
                id: thisFormData.get('id'),
                quantity: thisFormData.get('quantity') || 1,
                properties: {
                    ..._props,
                    _productType: 'primary',
                    _modelConfig: {},
                    _installationServiceMapping: {}
                }
            }

            const modelViewer = document.querySelector('ly-main-product ly-main-product-model-viewer')
            if (modelViewer) {
                for (const [key, value] of Object.entries(modelViewer._gltfMap)) {
                    const { url, transform, material: materialConfig, type } = value
                    if (type === 'yard') continue
                    primaryItem.properties._modelConfig[key] = { url, transform, materialConfig }
                }
                const preview = await modelViewer.getCartPreviewData()
                primaryItem.properties._configuratorState = preview.state
                primaryItem.properties._configuratorResources = preview.resources
                primaryItem.properties._configuratorView = preview.view
            }

            if (this.customProduct) {
                const [customProperties, customPropertiesForRead] = await Promise.all([this.customProduct.buildProperties(), this.customProduct.buildPropertiesForRead()])

                primaryItem.properties['_custom'] = 'pergola'
                primaryItem.properties['_custom_properties'] = customProperties
                Object.assign(primaryItem.properties, customPropertiesForRead)
            }

            if (this.customSidewall) {
                const customProperties = await this.customSidewall.buildProperties()
                primaryItem.properties['_custom'] = 'sidewall'
                primaryItem.properties['_custom_properties'] = customProperties
            }

            items.push(primaryItem)

            for (const item of this.sidewallCheckedInputs) {
                items.push({
                    id: item.dataset.variantId,
                    quantity: 1,
                    properties: {
                        ..._props,
                        _productType: 'sidewall'
                    }
                })
            }

            for (const item of this.sidewallAccessoryCheckedInputs) {
                const sidewallCheckedInput = item
                    .closest('ly-main-product-form-sidewall-picker-side-popover-sidewall')
                    .querySelector('.ly-main-product-form-sidewall-picker-side-popover-sidewall-picker-checkbox:checked')
                items.push({
                    id: item.dataset.variantId,
                    quantity: 1,
                    properties: {
                        ..._props,
                        _productType: 'sidewall_accessory',
                        _parent: sidewallCheckedInput.dataset.variantId
                    }
                })
            }

            for (const item of this.accessoryCheckedResult) {
                const id = item.checkedInput.dataset.variantId
                const quantity = +(item.quantityInput.value || 1)
                items.push({
                    id,
                    quantity,
                    properties: {
                        ..._props,
                        _productType: 'accessory',
                        _accessoryProduct: true
                    }
                })
            }

            const _createInstallationServiceItem = (id, quantity = 1) => ({
                id,
                quantity,
                properties: {
                    ..._props,
                    _productType: 'installation_service'
                }
            })

            if (this.installationServiceCheckbox?.checked && ((this.installationServiceZipCodeAvailable && this.enableInstallationServiceZipCodeCheck) || !this.enableInstallationServiceZipCodeCheck)) {
                items.push(_createInstallationServiceItem(this.installationServiceCheckbox.dataset.installationServiceVariantId, 1))

                for (const item of this.sidewallCheckedInputs) {
                    const id = item.dataset.installationServiceVariantId
                    if (!id) continue
                    items.push(_createInstallationServiceItem(id, 1))
                    primaryItem['properties']['_installationServiceMapping'][item.dataset.variantId] = id
                }

                for (const item of this.sidewallAccessoryCheckedInputs) {
                    const id = item.dataset.installationServiceVariantId
                    if (!id) continue
                    items.push(_createInstallationServiceItem(id, 1))
                    primaryItem['properties']['_installationServiceMapping'][item.dataset.variantId] = id
                }

                for (const item of this.accessoryCheckedResult) {
                    const id = item.checkedInput.dataset.installationServiceVariantId
                    const quantity = +(item.quantityInput.value || 1)
                    if (!id) continue
                    items.push(_createInstallationServiceItem(id, quantity))
                    primaryItem['properties']['_installationServiceMapping'][item.checkedInput.dataset.variantId] = id
                }
            }

            config.body = JSON.stringify({ items })

            return config
        }

        get customProduct() {
            return this.queryWrapper.querySelector('ly-main-product-form-custom-product')
        }

        get customSidewall() {
            return this.queryWrapper.querySelector('ly-main-product-form-custom-sidewall')
        }

        get installationServiceCheckbox() {
            return this.queryWrapper.querySelector('.ly-main-product-form-installation-service-picker-checkbox')
        }

        get enableInstallationServiceZipCodeCheck() {
            return this.queryWrapper.querySelector('ly-main-product-form-installation-service-picker').enableZipCheck
        }

        get installationServiceZipCodeAvailable() {
            return this.queryWrapper.querySelector('ly-main-product-form-installation-service-picker').isAvailableZipCode
        }

        handleErrorMessage = (errorMessage = '') => {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.error-message-wrapper')
            if (!this.errorMessageWrapper) return
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.error-message')
            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)
            if (!errorMessage) return
            this.errorMessage.textContent = errorMessage
        }

        startLoading = () => {
            this.submitButton.disabled = true
            this.spinner.classList.remove('hidden')
        }

        stopLoading = () => {
            this.submitButton.disabled = false
            this.spinner.classList.add('hidden')
        }

        _onVariantChange = ({ variantId }) => {
            this.input.value = variantId
            if (this.pickupDom) {
                this.pickupDom.dataset.variantId = variantId
            }
        }
    })
}
